/*******************************************************************************
TRIGGER TAB OPEN
Handles a click on any element and switches to the desired filter tab.
*******************************************************************************/

import switchTab from './switch-tab';

export default function triggerTabOpen(e) {

    // Get the name of the element that was clicked on and switch to it
    const $element = $(e.currentTarget);
    const tabName = $element.data('name');
    const tabSetName = $element.data('set');

    switchTab(tabSetName, tabName);
}
